import React, { useEffect, useState } from 'react';
import { Button, Divider } from 'antd';
import { AccountInfo } from '@/components/AccountInfo/AccountInfo';
import { IEntity } from '@/shared/interfaces/entity.interface';
import { useStore } from '@/stores';
import { COMMON } from '@/configs/main.config';
import { CloseOutlined } from '@ant-design/icons';
import { IWrapUp } from '@/shared/interfaces/wrapUp.interface';
import { observer } from 'mobx-react-lite';
import { MessageIcon } from '@/components/MessageIcon/MessageIcon';
import timerIcon from '@/public/icons/timer.svg';
import './WrapUp.scss';

interface WrapUpProps {
  wrapUp: IWrapUp;
  removeWrapUp: () => void;
}

export const WrapUp = observer(({ wrapUp, removeWrapUp }: WrapUpProps) => {
  const {
    callStore: { wrapUpSession },
  } = useStore();
  const [user, setUser] = useState<IEntity>(null);
  const [queueName, setQueueName] = useState<string>('');

  const parseTime = (time: number): string => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  useEffect(() => {
    if (wrapUpSession && wrapUpSession.remoteUser) {
      const currentUser = wrapUpSession.remoteUser.connectedUsers.length
        ? (wrapUpSession.remoteUser.connectedUsers[0] as IEntity)
        : ({
            ...COMMON.UNKNOWN_ENTITY,
          } as IEntity);
      setUser(currentUser);
      setQueueName(wrapUpSession.remoteUser.queueName);
    }
  }, []);

  return (
    <div className="wrap-up">
      {user && (
        <div className="account">
          <AccountInfo
            entity={user?.type}
            id={user?.id}
            size={40}
            fullName={user?.fullName}
            phone={user?.initialPhone}
          />
        </div>
      )}
      {queueName && (
        <span className="queue">{`Incoming call via ${queueName}`}</span>
      )}
      <Divider className="divider" />
      {wrapUp.show && (
        <div className="counter">
          <div className="counter-item">
            <span className="counter-title">Wrap up time:</span>
            <span className="counter-text">
              <MessageIcon svgUrl={timerIcon} /> {parseTime(wrapUp.time)}
            </span>
          </div>
          <Button
            onClick={removeWrapUp}
            data-testid="remove-wrap-up-main"
            danger
            type="primary"
            shape="circle"
            icon={<CloseOutlined />}
            size={'small'}
          ></Button>
        </div>
      )}
    </div>
  );
});
